import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Richtext from '../atoms/Richtext'

const TwoColWrapper = ({ block, children, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-two-col ${className} ${block.space_top} ${block.space_bottom}`}
      >
        <div className="content-block-two-col-body">
          <div className="row">
            <div className="content-col-2">
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                headline_level={block.headline_level}
                subheadline={block.subheadline}
              />
              <Richtext text={block.text} />
            </div>
            <div className="content-col-2">{children}</div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TwoColWrapper
